module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [(_vm.row.registstatus == 2) ? _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("备案成功")]), _vm._v(" "), _c('p', [_vm._v("请继续相关操作")])]) : (_vm.row.registstatus == 1) ? _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon icon-wait"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("等待审核中")]), _vm._v(" "), _c('p', [_vm._v("请等待管理员审核")])]) : (_vm.row.registstatus == 3) ? _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon icon-closed"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("审核未通过")]), _vm._v(" "), _c('p', [_vm._v("拒绝理由:" + _vm._s(_vm.row.registstatusdes))])]) : _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon icon-wait"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("未提交")]), _vm._v(" "), _c('p', [_vm._v("请先提交备案")])]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "单位",
      "value": _vm.row.danwei
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [(_vm.row.registstatus == 2 && false) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'Activity',
        'query': {}
      }),
      expression: "{name:'Activity','query':{ }}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("继续报名")]) : (_vm.row.registstatus == 3) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink.replace",
      value: ({
        name: 'ClubApply',
        'query': {}
      }),
      expression: "{name:'ClubApply','query':{ }}",
      modifiers: {
        "replace": true
      }
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("重新备案")]) : (_vm.row.registstatus == 0) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink.replace",
      value: ({
        name: 'ClubApply',
        'query': {}
      }),
      expression: "{name:'ClubApply','query':{ }}",
      modifiers: {
        "replace": true
      }
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("单位备案")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cad28840","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/CertClubResult.vue
// module id = 2583
// module chunks = 0